import { Box, Button, ButtonLink, Heading, Input, Stack, Text } from '@vouched.id/vault';
import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { VouchedLogo } from 'components/reusable/vouched-logo';
import { setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { forgotPassword } from 'store/sagas/sagas';
import { validateEmail } from 'utils/email';
import { FieldState } from 'utils/validation';
export const ForgotPassword = () => {
    const { asyncDispatch, dispatch } = useGlobalState();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [emailValidity, setEmailValidity] = useState(FieldState.NOT_SET);
    const [isLoading, setIsLoading] = useState(false);
    const handleEmailChange = useCallback((e) => {
        setEmail(e.target.value);
    }, []);
    const handleEmailBlur = useCallback((e) => {
        if (e.target.value === '') {
            setEmailValidity(FieldState.NOT_SET);
        }
        else {
            setEmailValidity(validateEmail(e.target.value) ? FieldState.VALID : FieldState.INVALID);
        }
    }, []);
    const submit = (event) => {
        event.preventDefault();
        if (isLoading) {
            return;
        }
        if (!validateEmail(email)) {
            setEmailValidity(FieldState.INVALID);
            return;
        }
        setIsLoading(true);
        setEmailValidity(FieldState.VALID);
        asyncDispatch(forgotPassword(email))
            .then((res) => {
            dispatch(setMessages({ value: 'Check your email', severity: 'success' }));
            navigate('/reset-password', { state: { sid: res.data } });
        })
            .catch((error) => {
            setIsLoading(false);
            setEmailValidity(FieldState.INVALID);
            console.error(error);
        });
    };
    // eventually update vault theme
    const midPurple = '#453FC1';
    return (React.createElement(Box, { alignItems: "flex-start", display: "flex", height: "100vh", justifyContent: "center", padding: "spacing.large", style: { boxSizing: 'border-box' }, tag: "main" },
        React.createElement(Box, { alignItems: "center", display: "flex", flexDirection: "column", justifyContent: "center", maxWidth: "52rem" },
            React.createElement(Box, { marginBottom: "spacing.xlarge3", marginTop: "spacing.default" },
                React.createElement(VouchedLogo, { fill: midPurple, maxWidth: "100%", width: "250px" })),
            React.createElement(Box, { marginBottom: "spacing.xlarge" },
                React.createElement(Heading, { style: { fontWeight: 'bold' }, tag: "h1", variation: "h3" }, "Forgot Password")),
            React.createElement(Text, null, "Enter the email associated with your account and we'll send you a code to reset your password."),
            React.createElement(Box, { marginTop: "spacing.large", noValidate: true, onSubmit: submit, tag: "form", width: "100%" },
                React.createElement(Stack, { spacing: "spacing.large" },
                    React.createElement(Box, null,
                        React.createElement(Input, { autoComplete: "email", inputMode: "email", isInvalid: emailValidity === FieldState.INVALID, label: "Email", name: "email", onBlur: handleEmailBlur, onChange: handleEmailChange, type: "email", validationMessage: "Invalid email address." })),
                    React.createElement(Box, { alignItems: "center", display: "flex", justifyContent: "center", width: "100%" },
                        React.createElement(Button, { "data-cy": "submit", style: { backgroundColor: midPurple }, title: isLoading ? 'loading' : '' }, "Send Code")),
                    React.createElement(ButtonLink, { "data-cy": "signin", href: "/signin", variation: "text" }, "Back to Login"))))));
};
